import React, { useState } from "react"
import type { PollCampaignProps } from "../../types"
import { Icons } from "../../Components"
import CampaignLeaderboard from "./CampaignLeaderboard"
import { Button, Text, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"

type CampaignResultProps = {
    poll_campaign:PollCampaignProps,
    onShowFullLeaderboard?:() => void
}

const CampaignResult = ({ poll_campaign, onShowFullLeaderboard } : CampaignResultProps) => {
    const [ expanded, setExpanded ] = useState(false);
    const Colors = useColors();

    return (
        <View float>
            <Button style={{ flexDirection:'row', alignItems:'center', padding:20, backgroundColor:Colors.views.header }} onPress={() => setExpanded(!expanded)}>
                <Icons.PodiumIcon size={18} color={Colors.text.h1} />
                <View transparent style={{flex:1, marginLeft:10}}>
                    <Text theme="h1">Leaderboard</Text>
                    <Text style={{ marginTop:3 }} theme="description">Below are the leaderboard results!</Text>
                </View>
                <Icons.ChevronIcon size={8} color={Colors.text.h1} direction={expanded ? 'up' : 'down'} />
            </Button>
            {expanded ?
            <View style={{ padding:0 }}>
                <CampaignLeaderboard
                    view_mode="short"
                    mode="mobile"
                    height={800}
                    poll_campaign={poll_campaign}
                    onShowFullLeaderboard={onShowFullLeaderboard}
                />
            </View>
            :<></>}
        </View>
    )
}

export default CampaignResult